export default function (px: number): number {
    return px / 12
}
